import { createContext, useContext, useState } from "react";
import { ScheduledMatch } from "../types";

type ActiveMatchContextType = {
  match: ScheduledMatch | null;
  setMatch?: (match: ScheduledMatch) => void;
};

const ActiveMatchContext = createContext<ActiveMatchContextType>({
  match: null,
  setMatch: undefined,
});

export function ActiveMatchProvider({
  initialMatch,
  children,
}: {
  initialMatch: ScheduledMatch;
  children: React.ReactNode;
}) {
  const [match, setMatch] = useState(initialMatch);

  return (
    <ActiveMatchContext.Provider value={{ match, setMatch }}>
      {children}
    </ActiveMatchContext.Provider>
  );
}

export function useActiveMatch() {
  return useContext(ActiveMatchContext);
}
